import { createSlice } from "@reduxjs/toolkit";
import TransactionMonitorService from "../../../app/data/transaction-monitor/transactionMonitorService";
import { IState } from "../..";
import { AppThunk } from "../../../app/store";
import { initialTransactionMessageDumpState } from "./TransactionMessagesState";

const transactionMonitorService = TransactionMonitorService.getInstance();

export const transactionMessageDumpSlice = createSlice({
  name: "transactionMessageDump",
  initialState: initialTransactionMessageDumpState,
  reducers: {
    resetTransactionMessageDump: (state) => initialTransactionMessageDumpState,
    transactionMessageDumpLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    transactionMessageDumpLoadingSucceed: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.id = payload.id;
      state.messageData = payload.messageData;
      state.messageDataFormat = payload.messageDataFormat;
      state.createdAt = payload.createdAt;
      state.createdBy = payload.createdBy;
    },
    transactionMessageDumpLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
      state.id = initialTransactionMessageDumpState.id;
      state.messageData = initialTransactionMessageDumpState.messageData;
      state.messageDataFormat = initialTransactionMessageDumpState.messageDataFormat;
      state.createdAt = initialTransactionMessageDumpState.createdAt;
      state.createdBy = initialTransactionMessageDumpState.createdBy;
    },
  },
});

export const {
  resetTransactionMessageDump,
  transactionMessageDumpLoadingStarted,
  transactionMessageDumpLoadingSucceed,
  transactionMessageDumpLoadingFailed,
} = transactionMessageDumpSlice.actions;

export const transactionMessageDumpSelector = (state: IState) => state.transactionMessageDump;

export const getTransactionMessageDump = (
  messageId: string
): AppThunk => async (dispatch) => {
  dispatch(transactionMessageDumpLoadingStarted());

  const response = await transactionMonitorService.getMessageDump(messageId);

  if (response.ok()) {
    dispatch(transactionMessageDumpLoadingSucceed(response.data));
  } else {
    dispatch(transactionMessageDumpLoadingFailed());
  }
};

const transactionMessageDumpReducer = transactionMessageDumpSlice.reducer;
export default transactionMessageDumpReducer;
